export const getNextLineNum = cart => {
  if (cart.length === 0) return 1
  const maxLineNum = Math.max(...cart.map(item => Number(item.LineNum) || 0))
  return maxLineNum + 1
}
